export default __webpack_public_path__ + "static/media/expand.3b66d749.svg";